import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getGoToBrandReferralsCTA } from "./shared";

export const BrandReferralHowToReferBrandIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return BRAND_REFERRALS_REFER_A_BRAND_TITLE(strictLocalize);
    },

    descriptionBuilder(_context) {
      return [BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const BRAND_REFERRALS_REFER_A_BRAND_TITLE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "How to refer a brand",
  });

const BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "You can invite a brand to sell on Faire by going to “Refer brands” in “Account”, either by adding their email or website or by sharing your referral link with them directly.",
  });
